import { CognitoUserPool } from "amazon-cognito-identity-js";

export const poolData = {
  UserPoolId: "ap-south-1_kr5mm3GWc",
  ClientId: "5i0sbb1mr3sdf797qt2c0mu68r",
};
export const indentityPoolId =
  "ap-south-1:3eccb792-02a7-44ba-a7f5-bb0bbadc2446";
export default new CognitoUserPool(poolData);
